import {
  Step,
  StepLabel,
  Stepper,
  styled,
  type StepIconProps,
} from '@mui/material';

import { Icon } from '../shared/icon';

export const WizardStepper = ({
  activeStep,
  stepsLabels,
}: {
  activeStep: number;
  stepsLabels: string[];
}) => {
  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      className='w-[80%] max-w-[1400px] mt-[12px] mb-[24px] mx-auto'
    >
      {stepsLabels.map((label) => (
        <Step key={label}>
          <StepLabel
            StepIconComponent={CircleStepIcon}
            slotProps={{
              label: {
                className: 'text-[12px] mt-[4px]',
              },
            }}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

const CircleStepIconWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  borderRadius: '50%',
  backgroundColor: 'var(--mui-palette-background-paper)', // or default
  zIndex: 1,
}));

function CircleStepIcon(props: StepIconProps) {
  const { completed, active } = props;

  return (
    <CircleStepIconWrapper>
      {completed ? (
        <Icon iconClass='material-symbols-check' />
      ) : (
        <div
          className='w-[8px] h-[8px] rounded-full'
          style={{
            backgroundColor:
              completed || active
                ? 'var(--mui-palette-primary-main)'
                : 'var(--mui-palette-background-disabled)',
          }}
        />
      )}
    </CircleStepIconWrapper>
  );
}
